import { render } from "./Holidays.vue?vue&type=template&id=5738c1eb"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"

import "./Holidays.vue?vue&type=style&index=0&id=5738c1eb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__